import type { NextRouter } from 'next/router';
import { VALID_LOCALES } from '@/constants';

export const getCurrentLandingPath = (router: NextRouter): string => {
	if (typeof window === 'undefined') {
		return router.asPath || '/';
	}
	const pathSegments = router.asPath.split('/').filter(Boolean);
	const pathWithoutLocale = pathSegments
		.filter(segment => !VALID_LOCALES.includes(segment))
		.join('/');
	return pathWithoutLocale ? `/${pathWithoutLocale}` : '/';
};
